/**
 * Display names for everything that can hurt the player, keyed by the `source`
 * string carried on `player:damaged` (see entities/Player.js's takeDamage).
 *
 * Boss and herald attack patterns already carry a written, player-facing name
 * (`AttackPattern`'s `name`, the same string the telegraph callout shouts), so
 * they need no entry here and pass straight through `damageSourceLabel`. Only
 * the sources whose id is an internal slug need translating: the minion type
 * ids (entities/*.js `this.type`) and the handful of run hazards that aren't
 * an entity at all.
 */
const SOURCE_LABELS = {
  // Minion types — MinionWaveSystem's ALL_MINION_TYPES plus the Act II "deep"
  // vocabulary bosses mix in via waveConfig.deepMinionTypes (ACT2-BIBLE §8).
  skirmisher: 'Skirmisher',
  charger: 'Charger',
  bomber: 'Bomber',
  warden: 'Warden',
  caster: 'Caster',
  trapper: 'Trapper',
  splitter: 'Splitter',
  leech: 'Leech',
  swarmling: 'Swarmling',
  orbiter: 'Orbiter',
  courtier: 'Courtier',
  anglerling: 'Anglerling',
  mirrorShade: 'Mirror Shade',
  muffler: 'Muffler',
  sinkweight: 'Sinkweight',

  // Hazards with no entity behind them.
  arenaPulse: 'Arena Pulse',
  bomberBlast: 'Bomber Detonation',
  // A dying minion's parting fan (BULLET-HELL.md §D6). Filed as the mechanic
  // rather than as the type that fired it — see SUICIDE.source.
  deathBurst: 'Death Burst',

  // The bucket DamageLedger files unattributed hits under, so the recap's
  // rows still sum to the damage actually taken.
  unknown: 'Unknown',
};

/** The label shown in the death recap, or a readable fallback. */
export function damageSourceLabel(source) {
  if (!source) return 'Unknown';
  return SOURCE_LABELS[source] ?? source;
}
